import add from 'lodash/add'
import {
  createThemeSelector,
  createVariableThemeSelectorCreator
} from './utils'

export const constantsSelector = createThemeSelector(theme => theme.constants)

export const getConstantSelector = createVariableThemeSelectorCreator(name =>
  createThemeSelector(constantsSelector, constants => constants[name])
)

export const bottomNavigationHeightSelector = getConstantSelector(
  'BOTTOM_NAVIGATION_HEIGHT'
)
export const bottomNavigationHeightLandscapeSelector = getConstantSelector(
  'BOTTOM_NAVIGATION_HEIGHT_LANDSCAPE'
)

export const maxPageWidthSelector = getConstantSelector('MAX_PAGE_WIDTH')

/* NavigationBar */
export const navigationBarBorderWidthSelector = getConstantSelector(
  'NAVIGATION_BAR_BORDER_WIDTH'
)
export const navigationBarHeightSelector = getConstantSelector(
  'NAVIGATION_BAR_HEIGHT'
)
export const navigationBarHeightTabletSelector = getConstantSelector(
  'NAVIGATION_BAR_HEIGHT_TABLET'
)
export const navigationBarHeightLandscapeSelector = getConstantSelector(
  'NAVIGATION_BAR_HEIGHT_LANDSCAPE'
)
export const navigationBarOuterHeightSelector = createThemeSelector(
  navigationBarHeightSelector,
  navigationBarBorderWidthSelector,
  add
)
export const navigationBarOuterHeightTabletSelector = createThemeSelector(
  navigationBarHeightTabletSelector,
  navigationBarBorderWidthSelector,
  add
)
export const navigationBarOuterHeightLandscapeSelector = createThemeSelector(
  navigationBarHeightLandscapeSelector,
  navigationBarBorderWidthSelector,
  add
)

/* ContentSectionHeading */
export const contentSectionHeadingTitleTypographyVariantSelector = getConstantSelector(
  'CONTENT_SECTION_HEADING_TITLE_TYPOGRAPHY_VARIANT'
)
export const contentSectionHeadingTitleSpacingBottomSelector = getConstantSelector(
  'CONTENT_SECTION_HEADING_TITLE_SPACING_BOTTOM'
)

/* Button Spacing */
export const buttonPaddingHorizontalSelector = getConstantSelector(
  'BUTTON_PADDING_HORIZONTAL'
)
export const buttonPaddingVerticalSelector = getConstantSelector(
  'BUTTON_PADDING_VERTICAL'
)
